import React from 'react';
import logo from '../../../Assets/Images/logo.png';
import { ExportProfile } from './ExportProfile';
import { useLocation } from "react-router-dom";

export const ExportProfile_Layout = () => {
    const { state } = useLocation();
    return (
        <div>
             <img src={logo} alt="RVParkIQ" />
             <hr />
            <ExportProfile state={state} />
           
        </div>
    )
}